/** Type of participants in an [[FintechApplication]]. */
export const PARTICIPANTS = ['COMPANY', 'SUPPLIER', 'FUNDER', 'APPLICANT'] as const;

export type Participant = typeof PARTICIPANTS[number];

export class Assignment {
  participant: string;
  roles?: string[];
  users?: number[];

  constructor(data: Partial<Assignment> = {}) {
    Object.assign(this, data);
  }
};